export default {
  fromValue (val) {
    switch (val) {
      case 'new':
        return 'Novo'
      case 'qualified':
        return 'Qualificado'
      case 'negotiation':
        return 'Negociando'
      case 'converted':
        return 'Convertido'
      case 'closed':
        return 'Encerrado'
      default:
        return val
    }
  }
}
